import { useIndexQuery } from 'api';
import { DateWithoutTime } from 'classes/DateWithoutTime';
import { useCurrentRole, useCurrentUser } from 'hooks/slices';
import { useAuthStore } from 'stores/authStore';
import { isFaksRole } from 'utils/rolesUtils';
import { useIsAdminImpersonating } from './slices/useCurrentUser';

export const useShouldAcceptCgu = () => {
  const currentUser = useCurrentUser();
  const currentResourceRole = useCurrentRole();
  const authToken = useAuthStore((state) => state.userToken);
  const isAdminImpersonating = useIsAdminImpersonating();
  // The role the user acts under: a resource role, or (for Faks staff) their Faks-org role.
  // Faks staff act under a Core::Resource role and skip the CGU.
  const actingRole = currentResourceRole ?? currentUser?.roles?.find(isFaksRole);
  const isExemptFromCgu = (!!actingRole && isFaksRole(actingRole)) || isAdminImpersonating;

  const globalSettingsQuery = useIndexQuery('core/global_settings', undefined, {
    enabled: !!currentUser,
    refetchOnWindowFocus: true,
  });

  const cguRequiredAt = globalSettingsQuery.data?.global_settings.cgu_required_at;
  const cguAcceptedAt = currentUser?.cgu_accepted_at;

  const isLoading =
    (!!authToken && !currentUser) || (globalSettingsQuery.isLoading && !!currentUser);

  const shouldAcceptCgu =
    !isExemptFromCgu &&
    !!cguRequiredAt &&
    (!cguAcceptedAt ||
      DateWithoutTime.fromDateTimeString(cguAcceptedAt).isBefore(
        DateWithoutTime.fromString(cguRequiredAt)
      ));

  return { shouldAcceptCgu, isLoading };
};
